import { seoKeys } from '@travel/traveler-core/utils/seo';
import { isNotEmptyArray } from '@travel/utils';

import type { SortKeysType } from 'constants/provider';
import type { PriceRangeType } from 'hooks/useFilterCount';

export type FilterFormProps = {
  maxPrice: PriceRangeType;
  minPrice: PriceRangeType;
  sortKey: SortKeysType;
  freeCancellation: boolean;
  features: string[];
  searchFeatures: string[];
};

function HiddenFilterForm(props: FilterFormProps) {
  const { maxPrice, minPrice, sortKey, freeCancellation, features } = props;

  return (
    <div data-testid="hiddenFilterForm-wrapper">
      {isNotEmptyArray(features) && (
        <input
          type="hidden"
          name="features"
          value={features?.join(',')}
          data-testid="hiddenFilterForm-features"
        />
      )}
      {maxPrice && (
        <input
          type="hidden"
          name="maxPrice"
          value={String(maxPrice)}
          data-testid="hiddenFilterForm-maxPrice"
        />
      )}
      {minPrice && (
        <input
          type="hidden"
          name="minPrice"
          value={String(minPrice)}
          data-testid="hiddenFilterForm-minPrice"
        />
      )}
      {freeCancellation && (
        <input
          type="hidden"
          name="freeCancellation"
          value={String(freeCancellation)}
          data-testid="hiddenFilterForm-freeCancellation"
        />
      )}
      {/* SEO Params */}
      {sortKey && (
        <input
          type="hidden"
          name={seoKeys.sortKey}
          value={sortKey}
          data-testid="hiddenFilterForm-sortKey"
        />
      )}
    </div>
  );
}

export default HiddenFilterForm;
